<p
  class="
  label f-label-xs
  {{ color() }} 
  {{ value() <= 9 ? 'single' : 'multiple' }}"
>
  {{ value() <= 99 ? value() : '99' }}
</p>
